import script from "./SupportDeskIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportDeskIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SupportDeskIcon.vue?vue&type=style&index=0&id=02e8d1cc&lang=css"

const __exports__ = script;

export default __exports__